<template>
  <div class="common-drag">
    <div
      class="drag-area flex justify-center items-center text-center w-full"
      :class="{ 'is-drag': isDrag }"
      @dragover.prevent.stop="!isDisabled && handleDragOver($event, false)"
      @dragleave.prevent.stop="!isDisabled && handleDragLeave($event, false)"
      @drop.prevent.stop="!isDisabled && handleDrop($event, false)"
      @click="!isDisabled && handleClick($event, false)"
    >
      <input type="file" class="hidden" />
      <div
        class="drag-description flex flex-col justify-items-center items-center gap-2"
      >
        <div class="drag-icon">
          <feather-icon
            :icon="'FileIcon'"
            class="p-0 inline-flex rounded-full mr-3 h-5"
            :class="[{}]"
            :style="{}"
            svgClasses="h-5"
          ></feather-icon>
        </div>
        <div class="drag-text">
          {{ text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*
 * ドラッグアンドドロップ
 */
export default {
  name: "M.CommonDrag",
  props: {
    text: {
      type: String,
      default: "ファイルをドロップ、またはクリックしてファイルを選択し、追加",
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      isDrag: false,
    };
  },
  methods: {
    handleDragOver(evt) {
      this.isDrag = true;
      evt.dataTransfer.dropEffect = "copy";
    },
    handleDragLeave(evt) {
      evt.dataTransfer.dropEffect = "none";
    },
  },
};
</script>

<style>
.common-drag {
  .drag-area {
    height: 100px;
    background-color: #f7f7f7;
    color: #808080;
    font-size: 12px;
    border: #bdbdbd solid 1px;
    border-radius: 6px;
  }
}
</style>
